import { computed, Ref, ComputedRef } from '@nuxtjs/composition-api';

type CmsElement = { plain_text?: string | null };
type CmsContainer = { code?: string; elements?: CmsElement[] };

function stripLdJsonScript(s: string): string {
  const m = s.match(/<script[^>]*type=["']application\/ld\+json["'][^>]*>([\s\S]*?)<\/script>/i);
  return m ? m[1] : s;
}

export default function useStructuredData(
  containers: Ref<CmsContainer[]>
): { structuredData: ComputedRef<Record<string, any> | null> } {
  const structuredData = computed<Record<string, any> | null>(() => {
    if (!Array.isArray(containers.value)) return null;

    const raw = containers.value
      .find(c => c.code === 'seo_container')
      ?.elements?.[0]?.plain_text;

    if (typeof raw !== 'string') return null;

    const text = stripLdJsonScript(raw).trim();

    try {
      let parsed: any = JSON.parse(text);

      if (typeof parsed === 'string') parsed = JSON.parse(parsed);

      return parsed && typeof parsed === 'object' ? parsed : null;
    } catch {
      return null;
    }
  });

  return { structuredData };
}
